import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'; // Use useNavigate instead of useHistory
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';

const ArticlesPage = () => {
  const [articles, setArticles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [error, setError] = useState(null);

  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    // Fetch departments
    fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_departments.php')
      .then(response => response.json())
      .then(data => setDepartments(data))
      .catch(error => console.error('Error fetching departments:', error));
  }, []);

  useEffect(() => {
    // Fetch articles
    axios.get('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/articles.php')
      .then(response => {
        setArticles(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching the articles!", error);
      });
  }, []);

  const departmentUrlMap = {
    "Obstetrics, Gynaecology and Fetal Medicine" : "/gynaecology",
    "Emergency Medicine & Trauma Care" : "/emergency-medicine",
    "Paediatrics & Paediatrics Surgery" : "/paediatrics-and-paediatrics-surgery",
    "Neonatology" : "/neonatology",
    "General Medicine" : "/general-medicine",
    "Dental, Oral & Maxillofacial Surgery" : "/dental",
    "General Surgery" : "/general-surgery",
    "Orthopaedics, Joint Replacement and Arthroscopy" : "/orthopaedics",
    "ENT & Audiology" : "/ent-audiology",
    "Plastic and Micro Vascular Surgery" : "/plastic-surgery",
    "Dermatology" : "/dermatology",
    "Ophthalmology" : "/ophthalmology",
    "Cardiology" : "/cardiology",
  };

  const handleDepartmentChange = (event) => {
    setSelectedDepartment(event.target.value);
  };

  const handleArticleClick = (articleId) => {
    navigate(`/article/${articleId}`); // Use navigate to redirect
  };

  const filteredArticles = selectedDepartment === 'all' 
    ? articles 
    : articles.filter(article => article.department === selectedDepartment);
  
  return (
    <div>
      {/* Navbar */}
      <Navbar />
      {/* Navbar Ending */}

      {/* Page Content starts here */}
      <section className="page-section">
        <div className="section-content">
          <p className='page-heading'>Articles To Read</p>

          <div className="d-none d-md-block"> {/* Visible on desktop, hidden on mobile */}
            <p className="page-subtitle">
              Access Comprehensive Wellness and Preventative Care Tips
              <br/> 
              to Enhance Your Daily Life
            </p>
          </div>

          <div className="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
            <p className="page-subtitle">
              Access Comprehensive Wellness and Preventative Care Tips to Enhance Your Daily Life
            </p>
          </div>

          <p>&nbsp;</p>

          <p>Filter by Department: </p>
          <div className="article-departments">
            <select className="article-department-select" onChange={handleDepartmentChange}>
              <option className="article-department-options" value="all">All Departments</option>
              {departments.map(dept => (
                <option className="article-department-options" key={dept.pk} value={dept.name}>{dept.name}</option>
              ))}
            </select>
          </div>
          
          <p>&nbsp;</p>

          <div className="articles-container">
            {filteredArticles.length > 0 ? (
              filteredArticles.map((article, index) => (
                <div className="article-card" key={index}>
                  <a href="" className="article-title"><img src={article.image_url} alt={article.title} className="article-image" onClick={() => handleArticleClick(article.id)} /></a>
                  <div className="article-info">
                    <Link to={departmentUrlMap[article.department] || "/"}>
                      {article.department}
                    </Link>
                    <a href="" className="article-title"><h6 onClick={() => handleArticleClick(article.id)}>{article.title}</h6></a>
                    <p>{new Date(article.created_date).toLocaleDateString('default', { month: 'long', year: 'numeric' })}</p>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-articles-message">No articles found for the selected department.</p>
            )}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
      {/* Footer Ending */}
    </div>
  );
}

export default ArticlesPage;
